import { DefinedPropertyObject, IEntityMinimalModel } from "../../../api/GenericTypes";
import { ZontalInformationPackageProfile, ZontalInformationPackageProfileFilters } from "../../../api/Zontal";
import { toValidDate } from "../../../common/datetime/DateTimeFormatter";
import { SplitDatePickerFormField } from "../../../common/formfields/DatePickerFormField/SplitDatePickerFormField";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import { FoldableFilters } from "../../../common/sidebar/filtersidebar/GenericFilters/common/FoldableFilters";
import {
  TabStoreFilterFormProvider,
  TabStoreFilterSidebarProps,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { ZontalEnteredBySelectForm, ZontalIPPSelectForm, ZontalModifiedBySelectForm } from "../../ZontalCommons";
import { defaultZontalIPPFilters } from "./ZontalIPPTable";

export interface ZontalInformationPackageProfileFilterForm {
  informationPackageProfiles?: IEntityMinimalModel<string>[] | undefined | null;
  enteredFrom?: Date | undefined | null;
  enteredTo?: Date | undefined | null;
  enteredBy?: IEntityMinimalModel<string>[] | undefined | null;
  modifiedFrom?: Date | undefined | null;
  modifiedTo?: Date | undefined | null;
  modifiedBy?: IEntityMinimalModel<string>[] | undefined | null;
}

const defaultValues: DefinedPropertyObject<ZontalInformationPackageProfileFilterForm> = {
  informationPackageProfiles: null,
  enteredFrom: null,
  enteredTo: null,
  enteredBy: null,
  modifiedFrom: null,
  modifiedTo: null,
  modifiedBy: null,
};

const zontalIPPFormToFilters = (
  form: ZontalInformationPackageProfileFilterForm
): ZontalInformationPackageProfileFilters => {
  let filters: ZontalInformationPackageProfileFilters = {};
  filters.informationPackageProfiles = form.informationPackageProfiles?.map((n) => n.id) ?? undefined;
  filters.enteredFrom = toValidDate(form.enteredFrom);
  filters.enteredTo = toValidDate(form.enteredTo);
  filters.modifiedFrom = toValidDate(form.modifiedFrom);
  filters.modifiedTo = toValidDate(form.modifiedTo);
  filters.enteredBy = form.enteredBy?.map((e) => e.id) ?? undefined;
  filters.modifiedBy = form.modifiedBy?.map((m) => m.id) ?? undefined;
  return filters;
};

export const ZontalIPPFilterBar = ({
  initialValues,
  onFormChange,
  dispatchTabStore,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<
  ZontalInformationPackageProfile,
  ZontalInformationPackageProfileFilterForm,
  ZontalInformationPackageProfileFilters
>) => {
  // const stateArray = [
  //   !!initialValues?.enteredFrom,
  //   !!initialValues?.enteredTo,
  //   !!initialValues?.modifiedFrom,
  //   !!initialValues?.modifiedTo,
  // ];

  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultZontalIPPFilters}
      formToFilters={zontalIPPFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          {/* <div style={{ minWidth: "200px" }}>
            <ToggleFormField id="includeInternals" control={control} label="Include internals" horizontal />
          </div> */}

          <ZontalIPPSelectForm
            id="informationPackageProfiles"
            label="Information Package Profiles"
            control={control}
            isMulti
          />
          <FoldableFilters
            label="Record information"
            // defaultOpen={stateArray.some((p) => p) && !!stateArray.length}
            defaultOpen
          >
            <ZontalEnteredBySelectForm id="enteredBy" label="Entered By" control={control} isMulti />

            <SplitDatePickerFormField
              control={control}
              idStart="enteredFrom"
              idEnd="enteredTo"
              label="Entered on (from - to)"
              horizontal={false}
              showTimeSelect
            />

            <ZontalModifiedBySelectForm id="modifiedBy" label="Modified By" control={control} isMulti />

            <SplitDatePickerFormField
              control={control}
              idStart="modifiedFrom"
              idEnd="modifiedTo"
              label="Last modified on (from - to)"
              horizontal={false}
              showTimeSelect
            />
          </FoldableFilters>
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
